/**
 * Class names the dashboard tour anchors its steps to.
 *
 * These are a contract between the dashboard markup and the tour config, not styling.
 * Both sides import from here so a rename can't drift: step 5 previously targeted
 * `.month-selector` while the markup rendered `.period-selector`, and react-joyride
 * responds to a missing target by emitting `error:target_not_found` and advancing, so
 * the step simply never rendered and nothing surfaced the mismatch.
 *
 * The breadcrumb step targets the page header. Everything from `assuranceLegend` down lives inside
 * the drilldown's `!isLoading` branch, and `addMetricCard` additionally renders only
 * when the viewer `canEdit` — which is false until permissions resolve. So the tour's
 * auto-start waits on both the calculation and permissions; see the gating effect in
 * GroupDrilldown.
 */
export const DASHBOARD_TOUR_TARGETS = {
  pager: 'reporting-pager',
  assuranceLegend: 'assurance-legend',
  trendToggle: 'trend-toggle',
  periodSelector: 'period-selector',
  complimindInsight: 'complimind-insight',
  heroTile: 'hero-tile',
  metricsGrid: 'metrics-grid',
  addMetricCard: 'add-metric-card'
} as const;

export type DashboardTourTarget = keyof typeof DASHBOARD_TOUR_TARGETS;

/** The CSS selector form, for react-joyride step targets. */
export function tourTarget(name: DashboardTourTarget): string {
  return `.${DASHBOARD_TOUR_TARGETS[name]}`;
}
